import 'debug';
import { _ as _asyncToGenerator, h as _regeneratorRuntime } from './index2.js';
import 'deepmerge';
import 'axios';
import 'vue';
import { _ as __vue_normalize__ } from './normalize-component.js';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var sleepTimeout = null;
var script = {
  name: 'Splash',
  data: function data() {
    return {
      secretAdminClicksCounter: 0,
      secretAdminClickStartTime: 0,
      secretAdminClickMaxTime: 3000,
      secretBleClicksCounter: 0,
      isLocationSettingsValid: true,
      deviceName: ''
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this = this;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.$xp.screen.setOrientation();
              this.$xp.screen.preventSleep();
              sleepTimeout = setTimeout(function () {
                _this.$xp.screen.allowSleep();
              }, this.$xp.settings.mergedSettings.screen.standbySeconds * 1000);
              _context.next = 5;
              return this.checkLocationSettings();

            case 5:
              this.getDeviceName();
              this.$el.querySelector('#start-xpedeo').focus();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    checkLocationSettings: function () {
      var _checkLocationSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.$xp.settings.mergedSettings.showLocationSettingsWarning) {
                  _context2.next = 10;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return this.$xp.device.checkLocationSettings();

              case 4:
                this.isLocationSettingsValid = true;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](1);
                this.isLocationSettingsValid = false;

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 7]]);
      }));

      function checkLocationSettings() {
        return _checkLocationSettings.apply(this, arguments);
      }

      return checkLocationSettings;
    }(),
    getDeviceName: function getDeviceName() {
      var _this2 = this;

      if (this.$xp.device.isLoan) {
        window.XpedeoPreloader.getDeviceName(function (name) {
          _this2.deviceName = name;
        }, function (error) {
          console.log('Error getting device name.');
          console.log(error);
        });
      }
    },
    onSecretAdminClick: function onSecretAdminClick() {
      var now = new Date().getTime();

      if (now - this.secretAdminClickStartTime > this.secretAdminClickMaxTime) {
        this.secretAdminClicksCounter = 1;
        this.secretAdminClickStartTime = now;
      } else {
        this.secretAdminClicksCounter++;
        console.log('admin click');

        if (this.secretAdminClicksCounter >= 5) {
          this.secretAdminClicksCounter = 0; // go to AdminActivity

          this.$xp.device.goToAdminActivity();
        }
      }
    },
    onForwardClick: function onForwardClick() {
      this.$router.push('/page/' + this.$xp.settings.mergedSettings.content.startPageID);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(sleepTimeout);
    this.$xp.screen.preventSleep();
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "c-splash",
      on: {
        touchstart: function($event) {
          if (
            $event.ctrlKey ||
            $event.shiftKey ||
            $event.altKey ||
            $event.metaKey
          ) {
            return null
          }
          return _vm.onSecretAdminClick($event)
        }
      }
    },
    [
      _c("h1", { staticClass: "sr-only" }, [
        _vm._v(_vm._s(_vm.$t("global.xpSplashHeading")))
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm.$xp.settings.mergedSettings.showDeviceName
        ? _c("div", { staticClass: "c-splash__device-name" }, [
            _vm._v("\n        " + _vm._s(_vm.deviceName) + "\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "c-splash__button",
          attrs: { id: "start-xpedeo", title: "Xpedeo starten", autofocus: "" },
          on: {
            click: function($event) {
              $event.stopPropagation();
              return _vm.onForwardClick($event)
            }
          }
        },
        [
          _c("img", {
            attrs: {
              alt: "",
              src:
                "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMC8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9UUi8yMDAxL1JFQy1TVkctMjAwMTA5MDQvRFREL3N2ZzEwLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4wIiBpZD0ieHBlZGVvIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB3aWR0aD0iOTYwcHgiIGhlaWdodD0iOTYwcHgiIHZpZXdCb3g9IjEwMS40MjQgMTIyLjE1NyA5NjAgOTYwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDEwMS40MjQgMTIyLjE1NyA5NjAgOTYwIgoJIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cmFkaWFsR3JhZGllbnQgaWQ9IlNWR0lEXzFfIiBjeD0iNTgxLjQ3ODgiIGN5PSI1OTcuNzAxOSIgcj0iNDgwIiBncmFkaWVudFRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIC0xIC0wLjA1NTIgMTE5OS44NTg5KSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgoJPHN0b3AgIG9mZnNldD0iMCIgc3R5bGU9InN0b3AtY29sb3I6I0ZGQTAwMCIvPgoJPHN0b3AgIG9mZnNldD0iMSIgc3R5bGU9InN0b3AtY29sb3I6I0ZGNkUwMCIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8cmVjdCB4PSIxMDEuNDI0IiB5PSIxMjIuMTU3IiBmaWxsPSJ1cmwoI1NWR0lEXzFfKSIgd2lkdGg9Ijk2MCIgaGVpZ2h0PSI5NjAiLz4KPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTg5My41NTksNTY5LjUzNEw2NzAuNzU0LDM1NC40MjljLTE2LjkyNS0xNi4zNTUtNDMuODgzLTE1Ljg2My02MC4yMDksMS4wNTkKCWMtMTYuMzI3LDE2LjkxOC0xNS44NTYsNDMuODY3LDEuMDY2LDYwLjIwM2wxNDYuOTM1LDE0MS44NTVsLTQ1OS42NjUtMC4yOTNjLTAuMDI4LDAtMC4wMjgsMC0wLjAyOCwwCgljLTIzLjUwNywwLTQyLjU3OSwxOS4wNDMtNDIuNTc5LDQyLjU1MWMtMC4wMjcsMjMuNTE2LDE5LjAzLDQyLjU5NCw0Mi41NTMsNDIuNjA4bDQ2Mi40MzcsMC4yOThMNjE0Ljg1NSw3ODkuMTU5CgljLTE2LjYxOCwxNi42MzQtMTYuNjE4LDQzLjU5MSwwLjAxNCw2MC4yMTZjOC4zMTYsOC4zMTUsMTkuMjEsMTIuNDY5LDMwLjEwNSwxMi40NjljMTAuODk1LDAsMjEuNzg5LTQuMTYsMzAuMTA0LTEyLjQ3OAoJTDg5NC4xLDYzMC4yNjljOC4wNjYtOC4wNzgsMTIuNTU4LTE5LjA2MiwxMi40NzQtMzAuNDg0QzkwNi40NjMsNTg4LjM2Miw5MDEuNzc5LDU3Ny40NjksODkzLjU1OSw1NjkuNTM0eiIvPgo8L3N2Zz4K"
            }
          })
        ]
      ),
      _vm._v(" "),
      !_vm.isLocationSettingsValid
        ? _c("i", {
            staticClass:
              "xp xp--large xp-map-marker location-settings-warning animated flash"
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass: "bg-tr",
          attrs: {
            id: "bg-tr-bottomleft",
            width: "320px",
            height: "320px",
            viewBox: "0 0 320 320"
          }
        },
        [
          _c("polygon", {
            attrs: {
              fill: "url(#bg-triangle)",
              points: "0,0 320,320 0,320 ",
              opacity: "0.25"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass: "bg-tr",
          attrs: {
            id: "bg-tr-bottomright",
            width: "320px",
            height: "320px",
            viewBox: "0 0 320 320"
          }
        },
        [
          _c("polygon", {
            attrs: {
              fill: "url(#bg-triangle)",
              points: "0,320 320,320 320,0 ",
              opacity: "0.25"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass: "bg-tr",
          attrs: {
            id: "bg-tr-topright",
            width: "320px",
            height: "320px",
            viewBox: "0 0 320 320"
          }
        },
        [
          _c("polygon", {
            attrs: {
              fill: "url(#bg-triangle)",
              points: "0,0 320,0 320,320 ",
              opacity: "0.25"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("svg", { attrs: { id: "defs" } }, [
        _c(
          "defs",
          [
            _c(
              "filter",
              { attrs: { id: "dropshadow", height: "130%" } },
              [
                _c("feGaussianBlur", {
                  attrs: { in: "SourceAlpha", stdDeviation: "2" }
                }),
                _vm._v(" "),
                _c("feOffset", {
                  attrs: { dx: "2", dy: "2", result: "offsetblur" }
                }),
                _vm._v(" "),
                _c(
                  "feComponentTransfer",
                  [_c("feFuncA", { attrs: { type: "linear", slope: "0.5" } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "feMerge",
                  [
                    _c("feMergeNode"),
                    _vm._v(" "),
                    _c("feMergeNode", { attrs: { in: "SourceGraphic" } })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "radialGradient",
              {
                attrs: {
                  id: "grey",
                  cx: "-50",
                  cy: "100",
                  r: "300",
                  gradientUnits: "userSpaceOnUse"
                }
              },
              [
                _c("stop", {
                  attrs: { offset: "0", "stop-color": "var(--color-stop-1)" }
                }),
                _c("stop", {
                  attrs: { offset: "1", "stop-color": "var(--color-stop-2)" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "radialGradient",
              {
                attrs: {
                  id: "bg-triangle",
                  cx: "-50",
                  cy: "100",
                  r: "300",
                  gradientUnits: "userSpaceOnUse"
                }
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#C5C6C6" },
                  attrs: { offset: "0" }
                }),
                _vm._v(" "),
                _c("stop", {
                  staticStyle: { "stop-color": "#9C9C9C" },
                  attrs: { offset: "1" }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
};
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "c-splash__logo" }, [
      _c("img", {
        attrs: {
          alt: "Xpedeo logo",
          src:
            "data:image/svg+xml;base64,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"
        }
      })
    ])
  }
];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
